<template>
  <div v-if="!isDismissed" class="stuffed-item" :class="{'has-image':hasImage}">
    <div v-if="hasImage" class="stuffed-item-avatar">
      <img :src="item.avatar">
    </div>
    <div class="stuffed-item-text">
      <p><a :href="item.userUrl">{{ item.name }}</a> commented on <a :href="item.articleUrl">{{ item.title }}</a></p>
      <p>{{ item.text }}</p>
    </div>
    <div class="level is-mobile stuffed-item-meta">
      <div class="level-left">
        <div class="level-item">
          <div v-if="isLikeable" class="buttons">
            <button type="button" class="button is-small" :class="{'is-loading':isThumbUpLoading, 'is-info':isLiked}" :disabled="isDisliked" @click.prevent="thumbUp">
              <b-icon icon="thumb-up" custom-size="default"></b-icon>
            </button>
            <button type="button" class="button is-small" :class="{'is-loading':isThumbDownLoading, 'is-danger':isDisliked}" :disabled="isLiked" @click.prevent="thumbDown">
              <b-icon icon="thumb-down" custom-size="default"></b-icon>
            </button>
          </div>
          <div v-else class="tags">
            <span v-if="item.status" :class="'tag is-' + item.status">{{ item.status }}</span>
            <span class="tag">
              <b-icon icon="clock-outline" custom-size="default"/>
              <span>{{ timeAgo }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button v-if="isDismissable" type="button" class="button is-small" :class="{'is-loading':isDismissLoading}" @click.prevent="dismiss">
            <b-icon icon="close" custom-size="default"></b-icon>
            <span>Dismiss</span>
          </button>
          <span v-else class="tag">
            <b-icon icon="clock-outline" custom-size="default"/>
            <span>{{ timeAgo }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: "StuffedItem",
    data() {
      return {
        isThumbUpLoading: false,
        isThumbDownLoading: false,
        isDismissLoading: false,

        isLiked: false,
        isDisliked: false,
        isDismissed: false,
      }
    },
    props: {
      isLikeable: {
        type: Boolean,
        default: false,
      },
      isDismissable: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      hasImage() {
        return (this.item && this.item.avatar)
      },
      timeAgo() {
        return moment.unix(this.item.timestamp).from(moment())
      }
    },
    methods: {
      thumbUp() {
        if (this.isLiked) {
          this.$toast.open({
            message: 'Like removed',
            type: 'is-danger'
          })
          this.isLiked = false
        } else {
          this.isThumbUpLoading = true

          // Below is an imitated loading-state behavior
          setTimeout(() => {
            this.isLiked = true
            this.isThumbUpLoading = false
            this.$snackbar.open('Liked successfully')
          }, 500)
        }
      },
      thumbDown() {
        if (this.isDisliked) {
          this.$toast.open({
            message: 'Dislike removed',
            type: 'is-danger'
          })
          this.isDisliked = false
        } else {
          this.isThumbDownLoading = true

          // Below is an imitated loading-state behavior
          setTimeout(() => {
            this.isDisliked = true
            this.isThumbDownLoading = false
            this.$snackbar.open('Disliked successfully')
          }, 500)
        }

      },
      dismiss() {
        this.isDismissLoading = true
        setTimeout(() => {
          this.isDismissed = true
          this.isDismissLoading = false
          this.$snackbar.open('Dismissed successfully')
        }, 500)
      },
    }
  }
</script>

<style scoped>

</style>